import { URLS } from '../../../constants';
import apiClient from '../../client';

const claimServicesAPI = {
  saveClaimServices: ({ data }: { data: any }) =>
    apiClient.post(URLS.saveClaimServices, {
      data: {
        data,
      },
    }),
  editClaimServices: ({
    id,
    claimId,
    userId,
    organizationId,
    place,
    units,
    charges,
    serviceDate,
    modifier1,
    modifier2,
    modifier3,
    modifier4,
    pointers,
    providerId,
    primaryId,
    authorizationCodeId,
    unitQualifierId,
    type,
    serviceProviderId,
    servicePlaceId,
  }: {
    id: any;
    claimId: any;
    userId: any;
    organizationId: any;
    place: any;
    units: any;
    charges: any;
    serviceDate: any;
    modifier1: any;
    modifier2: any;
    modifier3: any;
    modifier4: any;
    pointers: any;
    providerId: any;
    primaryId: any;
    authorizationCodeId: any;
    unitQualifierId: any;
    type: any;
    serviceProviderId: any;
    servicePlaceId: any;
  }) =>
    apiClient.post(URLS.editClaimServices, {
      data: {
        id,
        claimId,
        userId,
        organizationId,
        place,
        units,
        charges,
        serviceDate,
        modifier1,
        modifier2,
        modifier3,
        modifier4,
        pointers,
        providerId,
        primaryId,
        authorizationCodeId,
        unitQualifierId,
        type,
        serviceProviderId,
        servicePlaceId,
      },
    }),
  getClaimServicesById: ({ claimId }: { claimId: any }) =>
    apiClient.post(URLS.getClaimServicesById, {
      data: {
        claimId,
      },
    }),
  getClaimServicesSummaryById: ({ claimId }: { claimId: any }) =>
    apiClient.post(URLS.getClaimServicesSummaryById, {
      data: {
        claimId,
      },
    }),
  generatePatientServicesSummary: ({ claimId }: { claimId: any }) =>
    apiClient.post(URLS.generatePatientServicesSummary, {
      data: {
        claimId,
      },
    }),
  getNpiNumber: ({
    userSpecificId,
    organizationId,
  }: {
    userSpecificId: any;
    organizationId: any;
  }) =>
    apiClient.post(URLS.getNpiNumber, {
      data: {
        userSpecificId,
        organizationId,
      },
    }),
  deleteClaimServicesById: ({ id }: { id: any }) =>
    apiClient.post(URLS.deleteClaimServicesById, {
      data: {
        id,
      },
    }),
  getBillingCode: ({ authorizationId }: { authorizationId: any }) =>
    apiClient.post(URLS.getBillingCode, {
      data: {
        authorizationId,
      },
    }),
  getAllUnitQualifier: () =>
    apiClient.post(URLS.getAllUnitQualifier, {
      data: {},
    }),
  getExistingBillingRecords: ({
    authorizationId,
    claimId,
    clientId,
  }: {
    authorizationId: any;
    claimId: any;
    clientId: any;
  }) =>
    apiClient.post(URLS.getExistingBillingRecords, {
      data: {
        authorizationId,
        claimId,
        clientId,
      },
    }),
  getSecondaryInsurances: ({ clientId }: { clientId: string }) =>
    apiClient.post(URLS.getSecondaryInsurances, {
      data: {
        clientId,
      },
    }),
};
export default claimServicesAPI;
